// Lectura del nivel:
//   1. localStorage.getItem('epc.log.level') si existe (override runtime)
//   2. 'debug' en NODE_ENV !== 'production'
//   3. 'warn' en producción
const LEVELS = { debug: 0, info: 1, warn: 2, error: 3, silent: 99 }

function resolveLevel() {
  const ls = typeof window !== 'undefined' ? localStorage.getItem('epc.log.level') : null
  if (ls && LEVELS[ls] !== undefined) return LEVELS[ls]
  return process.env.NODE_ENV === 'production' ? LEVELS.warn : LEVELS.debug
}

const STYLES = {
  brand: 'background:#5577BB;color:#fff;padding:1px 4px;border-radius:2px;font-weight:bold',
  debug: 'background:#9CA3AF;color:#fff;padding:1px 4px;border-radius:2px',
  info:  'background:#3B82F6;color:#fff;padding:1px 4px;border-radius:2px',
  warn:  'background:#F59E0B;color:#000;padding:1px 4px;border-radius:2px',
  error: 'background:#EF4444;color:#fff;padding:1px 4px;border-radius:2px',
  msg:   'color:inherit',
}

export function createLogger(tag) {
  const minLevel = resolveLevel()
  const prefix = (level) => [
    `%cEPC-TRACKER%c ${tag}%c`,
    STYLES.brand,
    STYLES[level],
    STYLES.msg,
  ]

  const make = (level, consoleFn) => (...args) => {
    if (LEVELS[level] < minLevel) return
    consoleFn(...prefix(level), ...args)
  }

  return {
    debug:    make('debug', console.log),
    info:     make('info',  console.info),
    warn:     make('warn',  console.warn),
    error:    make('error', console.error),
    group:    (...a) => { if (LEVELS.debug >= minLevel) console.group(...a) },
    groupEnd: ()     => { if (LEVELS.debug >= minLevel) console.groupEnd() },
  }
}
